module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAIJJREFUKFOVUjEKBCEMnKCFgoX4/w9aKBaKFmqWLGxz7HFnmoFhJmSSEDMzAAj03jHGwJxTKGitYYyBtRZEdHMkhrUWSikQfCulFLz3EKS9N+ecv4qfBiIOIYBaa1xrfe38STrnQCklfmb+5ZJMFGO8Q/9b54bjkY5DH6/1+HCnr3EBqHFwq5HmG4oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/dot-icon.png
// module id = H7co
// module chunks = 1